export default "__VITE_ASSET__GdXPMT1C__"